export function renderNetraaLHReleaseNotes6() {
  return (
    <div>
      <main className="transition-opacity duration-300">
        <div className="py-4">

          {/* Header */}
          <div id="release-details" className="mb-10 scroll-mt-24">
            <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
              Release Notes
            </span>

            <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
                Netraa LH Release Notes
              </span>
            </h1>

            <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
              Latest updates including feature enhancements, performance improvements, and bug fixes.
            </p>
          </div>

          {/* Document Authors */}
          <section id="" className="mb-12">
            <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
              Release Details
            </h2>

            <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
              <table className="w-auto text-left border-collapse text-sm">
                <thead>
                  <tr>
                    <th className="px-4 py-3 font-bold text-text-muted">Name</th>
                    <th className="px-4 py-3 font-bold text-text-muted">Title</th>
                    <th className="px-4 py-3 font-bold text-text-muted">Email</th>
                    <th className="px-4 py-3 font-bold text-text-muted">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-3 font-medium text-primary">Navodya Tyagi</td>
                    <td className="px-4 py-3">Project Manager</td>
                    <td className="px-4 py-3">navodya.tyagi@ap2l.ai</td>
                    <td className="px-4 py-3">26th May, 2026</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* Introduction */}
          <section id="introduction" className="mb-12 scroll-mt-24">
            <div className="p-6 rounded-2xl bg-gradient-to-r from-orange-50 to-transparent dark:from-orange-900/20 dark:to-transparent border border-border-color dark:border-border-dark">
              <h2 className="text-2xl font-bold text-text-main dark:text-white mb-3">
                Introduction
              </h2>
              <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
                We are excited to announce the latest updates to our platform Netraa LH, packed with several feature enhancements, improvements, and bug fixes. This release aims to provide a better user experience, streamline processes, and increase overall efficiency.
              </p>
            </div>
          </section>

          {/* Key Enhancements */}
          <section id="enhancements" className="mb-16 scroll-mt-24">
            <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
              Release Notes
            </h2>

            <div className="space-y-6">

              {[
                {
                  title: "Informational View for Escalated Monitors",
                  items: [
                    "An informational (\"i\") button has been introduced next to escalated monitors, allowing users to quickly view escalation remarks and associated context directly from the Live Dashboard."
                  ]
                },
                {
                  title: "Enhanced Exception Handling Workflow",
                  items: [
                    "The escalation workflow has been improved to provide greater operational flexibility and ease of use. Enhancements include:",
                    "Support for Current Date Error Escalation",
                    "End Time is now mandatory only for Scheduled Downtime exceptions",
                    "Other exception categories no longer require mandatory end-time input. This simplifies exception handling during active monitoring scenarios."
                  ]
                },
                {
                  title: "Complete Dataset Export for Escalation Reports",
                  items: [
                    "Excel downloads from the Escalation History section now include the complete dataset instead of only the records visible on the current page.",
                    "This ensures more accurate reporting and easier historical analysis."
                  ]
                },
                {
                  title: "KPI Dashboard Report Enhancement",
                  items: [
                    "KPI Dashboard Excel exports now include:",
                    "Pages Monitored Count",
                    "This enhancement improves operational reporting visibility and reporting completeness."
                  ]
                },
                {
                  title: "Improved Client Clubbing Accuracy",
                  items: [
                    "Resolved an issue where monitor counts outside selected client groups were incorrectly displayed during client-level analysis on the Live Dashboard.",
                    "This improves visibility and accuracy while analyzing client-specific monitor data."
                  ]
                },
                {
                  title: "Improved Sorting Across Reports & Dashboard",
                  items: [
                    "Sorting behavior has been enhanced across multiple modules:",
                    "Escalation History sorting now applies across the complete dataset",
                    "Live Dashboard and Historical Data sorting now function independently",
                    "These improvements ensure more consistent and reliable data handling."
                  ]
                },
                {
                  title: "Enhanced Page Stability on Escalation History",
                  items: [
                    "Users navigating the Escalation History section will now experience improved state retention, ensuring that the selected page remains stable during interactions and navigation."
                  ]
                },
                {
                  title: "Improved Handling of Large Historical Datasets",
                  items: [
                    "Optimizations have been introduced for viewing historical monitoring data across larger time ranges.",
                    "This significantly improves application responsiveness and stability when handling extended historical datasets."
                  ]
                }
              ].map((item, i) => (
                <div key={i} className="p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark">
                  <div className="flex gap-4">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 font-bold text-sm">
                      {i + 1}
                    </div>
                    <div>
                      <h4 className="font-semibold text-text-main dark:text-white mb-2">
                        {item.title}
                      </h4>
                      <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                        {item.items.map((p, j) => (
                          <li key={j}>{p}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </section>

         {/* Focus of This Release */}
<section id="impact" className="mb-16 scroll-mt-24">
  <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
    Focus of This Release
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {[
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        ),
        label: "Improved operational visibility"
      },
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        ),
        label: "More intuitive escalation workflows"
      },
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        ),
        label: "Better reporting accuracy"
      },
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        ),
        label: "Enhanced application stability"
      },
      {
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        label: "Smoother user interactions across monitoring modules"
      }
    ].map((item, i) => (
      <div
        key={i}
        className="flex items-start gap-4 p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark group hover:border-orange-300 dark:hover:border-orange-700 hover:shadow-md transition-all duration-200"
      >
        <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-xl bg-orange-100 dark:bg-orange-900/30 text-orange-500 dark:text-orange-400 group-hover:bg-orange-200 dark:group-hover:bg-orange-900/50 transition-colors duration-200">
          {item.icon}
        </div>
        <p className="text-sm font-medium text-text-main dark:text-white leading-snug pt-2">
          {item.label}
        </p>
      </div>
    ))}
  </div>
</section>

        </div>
      </main>
    </div>
  );
}

